import React, { useEffect, useRef } from "react";
import { FormUi } from "../../ui/FormUi";
import { UsuarioForm } from "./UsuarioForm";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "antd";
import {
  SWR_get_rutas,
  usuarioClearActive,
  usuarioStartAdd,
  usuarioStartUpdate,
} from "../../../actions/usuario";
import dayjs from "dayjs";
import { fn_LoadChildren } from "../../../helpers/loadSeguridad";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  username: data?.username || null,
  password: data?.password || null,
  first_name: data?.first_name || null,
  last_name: data?.last_name || null,
  email: data?.email || null,
  is_superuser: data?.is_superuser || false,
  is_staff: data?.is_staff || false,
  is_active: data?.is_active || false,
  perfilesusuario: data?.perfilesusuario || [],
  accesosusuario: data?.accesosusuario || [],
});
const useResetFormOnClose = ({
  form,
  open,
  isLoadingTreeData,
  activeUsuario,
}) => {
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
    if (open) {
      //Abrir Modal
      if (activeUsuario) {
        //entro editar
        const perfilesusuario = activeUsuario?.perfilesusuario?.map(
          (row) => row.perfil
        );
        const accesosusuario = activeUsuario?.accesosusuario?.map(
          (row) => row.ruta
        );
        !isLoadingTreeData &&
          form.setFieldsValue({
            ...activeUsuario,
            perfilesusuario,
            accesosusuario,
          });
      }
      //entro nuevo
      else form.setFieldsValue({ id: new dayjs().valueOf() });
    }
  }, [form, prevOpen, open]);
};
export const UsuarioScreen = ({ openForm, handleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { data, isLoading } = SWR_get_rutas(true);
  const treeData = fn_LoadChildren({ allRutas: data, patternId: null });
  const { activeUsuario } = useSelector((state) => state.usuario);

  useResetFormOnClose({
    form,
    open: openForm,
    isLoadingTreeData: isLoading,
    activeUsuario,
  });
  const handleCancel = () => {
    dispatch(usuarioClearActive());
    handleCloseForm();
  };
  const handleSave = (values) => {
    values = {
      ...values,
      perfilesusuario: values?.perfilesusuario?.map((row) => ({ perfil: row })),
      accesosusuario: values?.accesosusuario?.map((row) => ({ ruta: row })),
    };
    if (activeUsuario) dispatch(usuarioStartUpdate(values));
    else dispatch(usuarioStartAdd(values));

    handleCancel();
  };
  return (
    <FormUi
      form={form}
      name="FormUsuario"
      layout="vertical"
      autoComplete="off"
      initialValues={initialValues()}
      handleSubmit={handleSave}
    >
      <UsuarioForm treeData={treeData} HandleCloseForm={handleCancel} />
    </FormUi>
  );
};
